// src/hooks/useBusinessTypeMaster.js
import { useEffect, useState } from "react";
import CommonService from "../services/common.service";

export function useBusinessTypeMaster() {
  const [businessTypes, setBusinessTypes] = useState([]);
  const [timezones, setTimezones] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await CommonService.get("/master/company-businesstypes");
        
        // Extract data from response
        if (response && response.success && response.data) {
          const apiBusinessTypes = response.data.master_business_types || [];
          const apiTimezones = response.data.master_timezone || [];
          
          setBusinessTypes(apiBusinessTypes);
          setTimezones(apiTimezones);
        }
      } catch (error) {
        console.error("Error fetching data from API:", error);
      } finally {
        setLoading(false);
      }
    }
    
    fetchData();
  }, []);

  // Map to react-select format { value, label }
  // Handle API format: {business_type_id: 1, business_type: 'Distributor'}
  const businessTypeOptions = businessTypes.map((bt) => {
    const value = bt.business_type_id || bt.id || bt.value;
    const label = bt.business_type || bt.label || bt.name;
    return { value, label };
  }).filter(opt => opt.value !== undefined && opt.value !== null && opt.label);

  // Map timezones to react-select format { value, label }
  // API format: {timezone_id: 1, timezone_label: '(UTC-11:00) Midway Island'}
  const mappedTimezones = timezones.map((tz, index) => {
    // Use timezone_id as value (API returns: timezone_id, timezone_label)
    const value = tz.timezone_id || tz.timezone_value || tz.value || tz.id || tz.timezoneValue;
    // Use timezone_label as label
    const label = tz.timezone_label || tz.label || tz.name || tz.timezoneLabel || tz.timezone;
    return { value, label };
  });
  
  const timezoneOptions = mappedTimezones.filter((opt, index) => {
    // Filter: keep if both value and label exist
    // Value can be number (timezone_id) or string
    const hasValue = opt.value !== undefined && opt.value !== null && String(opt.value).trim() !== '';
    const hasLabel = opt.label !== undefined && opt.label !== null && String(opt.label).trim() !== '';
    return hasValue && hasLabel;
  });

  return {
    businessTypes,
    businessTypeOptions,
    timezones,
    timezoneOptions,
    loading
  };
}

